// extracted by mini-css-extract-plugin
export default {"component":"b1F9EZ","title":"c1F9EZ","type-full":"d1F9EZ","type-icon-small":"e1F9EZ"};